import { omit } from 'lodash';
import callRevokeApiKey from '../api/revokeApiKey';
import { callApi, setState } from '../../util';
import { ApiKeysNameSpaceState } from '../types';

export default function* revokeApiKey(apiKeyId: string, orgId: string) {
  yield callApi(`apiKey/revoke/${apiKeyId}`, callRevokeApiKey, apiKeyId, orgId);
  yield setState('apiKeys', (state: ApiKeysNameSpaceState) => omit(state, apiKeyId));
}
